// Filename: /src/components/CommentSection/commentApi.js

import { getApi, postApi } from '../../services/apiService'; // Asegúrate que la ruta sea correcta
import UrlConfig from '../../data/UrlConfig'; // Asegúrate que la ruta sea correcta

// --- MOCK DATA SIMULANDO RESPUESTA DEL BACKEND ---
// NOTA: El backend ahora debe incluir `currentUserVote` para el usuario autenticado.
const mockComments = {
  'meditation-healing-101': [
    {
      id: 'c1',
      author: { id: 'u2', name: 'Elena' },
      content: 'This meditation was incredibly powerful. I felt a profound sense of peace afterward.',
      upvotes: 22, downvotes: 1,
      timestamp: new Date(Date.now() - 3600000).toISOString(),
      currentUserVote: 'up', // El usuario actual ya ha votado 'up' en este comentario.
      replies: [
        {
          id: 'c3',
          author: { id: 'u1', name: 'Admin' },
          content: 'So glad to hear that, Elena! Consistency is key.',
          upvotes: 8, downvotes: 0,
          timestamp: new Date(Date.now() - 1800000).toISOString(),
          replyingTo: { id: 'c1', authorName: 'Elena' },
          currentUserVote: null, // El usuario actual no ha votado en esta respuesta.
          replies: []
        },
      ]
    },
    {
      id: 'c2',
      author: { id: 'u3', name: 'David' },
      content: 'Does anyone have tips for staying focused during the entire session?',
      upvotes: 15, downvotes: 0,
      timestamp: new Date(Date.now() - 86400000).toISOString(),
      currentUserVote: null, // El usuario actual no ha votado aquí.
      replies: []
    }
  ],
};


/**
 * Busca todos los comentarios de un hilo específico desde la API.
 * EL BACKEND DEBE INCLUIR EL CAMPO `current_user_vote` EN CADA COMENTARIO.
 * @param {string} threadId - El identificador único del hilo de comentarios.
 * @returns {Promise<Array>} Una promesa que resuelve con un array de comentarios.
 */
export const fetchCommentsByThread = async (threadId) => {
  // --- LÓGICA DE PRODUCCIÓN (DESCOMENTAR CUANDO ESTÉ LISTO) ---
  return getApi(UrlConfig.comments_get_by_thread, { threadId });

  // --- LÓGICA DE SIMULACIÓN (USANDO MOCK DATA) ---
  console.log(`Fetching comments for thread: ${threadId}`);
  await new Promise(resolve => setTimeout(resolve, 500)); // Simular latencia
  const comments = mockComments[threadId] || [];
  return comments.sort((a, b) => (b.upvotes - b.downvotes) - (a.upvotes - a.downvotes));
};

/**
 * Publica un nuevo comentario o respuesta en la API.
 * @param {object} commentData - Los datos del comentario.
 * @returns {Promise<object>} Una promesa que resuelve con el nuevo objeto de comentario creado.
 */
export const postComment = ({ threadId, content, parentId = null, replyingTo = null }) => {
  const bodyData = { threadId, content, parentId, replyingTo };
  return postApi(UrlConfig.comments_post, bodyData);
};

/**
 * Envía un voto para un comentario específico a la API.
 * @param {string} commentId - El ID del comentario que se está votando.
 * @param {'up' | 'down' | 'neutral'} voteType - El tipo de voto ('neutral' para cancelar).
 * @returns {Promise<object>} Una promesa que resuelve con la confirmación de la API.
 */
export const voteOnComment = (commentId, voteType) => {
  return postApi(UrlConfig.comments_vote, { voteType, commentId });
};